import iZitoast from "izitoast";
import "izitoast/dist/css/iziToast.min.css";

const toast = {
  success: (
    message,
    position = "topCenter",
    backgroundColor = "#039de9",
    timeout = 5000
  ) => {
    return iZitoast.success({
      message,
      position,
      timeout,
      backgroundColor,
    });
  },

  error: (
    message,
    backgroundColor = "#FF6969",
    position = "topCenter",
    timeout = 5000
  ) => {
    return iZitoast.error({
      message,
      position,
      timeout,
      backgroundColor,
    });
  },
  info: (
    message,
    backgroundColor = "#30E3DF",
    position = "topCenter",
    timeout = 5000
  ) => {
    return iZitoast.info({
      message,
      position,
      timeout,
      backgroundColor,
    });
  },
  warning: (
    message,
    backgroundColor = "#F9D949",
    position = "topCenter",
    timeout = 5000
  ) => {
    return iZitoast.warning({
      message,
      position,
      timeout,
      backgroundColor,
    });
  },
};

export default toast;
